
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-touring",
      function () {
        return require("private-next-pages/self-touring.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/self-touring"])
      });
    }
  